import { render } from "./Editegrement.vue?vue&type=template&id=cd1b5e0a&scoped=true"
import script from "./Editegrement.vue?vue&type=script&lang=js"
export * from "./Editegrement.vue?vue&type=script&lang=js"

import "./Editegrement.vue?vue&type=style&index=0&id=cd1b5e0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd1b5e0a"]])

export default __exports__